import { render } from "./AnatomiaLOV.vue?vue&type=template&id=ba5d8a32"
import script from "./AnatomiaLOV.vue?vue&type=script&lang=js"
export * from "./AnatomiaLOV.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__